import axios from 'axios'
import cookie from 'js-cookie'
// import store from '../store/index'

// 参数不全(400), 请求通过(200), 请求出错(401), 未找到资源(404), 非法请求(201), 程序错误(500)，登录过期(201);
const API__code = { 
  SUCCESS: '200',    //成功
  ERROR401: '401',    //请求出错(用户名已注册)
  LOGONEXPIRES: '403',    //登录过期
  ERROR500: '500',    //服务器异常
  NOAUTH: '505',    //无权限
}

// 全局配置的默认值
// axios.defaults.baseURL = 'http://192.168.100.84:6688';
// axios.defaults.headers.common['Data'] = '';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 超时时间
// axios.defaults.timeout = 5000;

//HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    const meta = config.meta || {};
        //读取cookie
    let token
    let checkCode

    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('='); //再次切割
        //判断查找相对应的值
        if (arr2[0] == 'dnnypt_token') {
          token = arr2[1]; //保存到保存数据的地方
        } else if (arr2[0] == 'dnnypt_checkCode') {
          checkCode = arr2[1];
        }

      }
    }

    // const token = cookie.get("dnnypt_token");
    // const checkCode = cookie.get("dnnypt_checkCode");
    if (token && checkCode) {
      config.params = {
        token: token,
        checkCode: checkCode
      }
    }
    // config.headers["token"] = token; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    // config.headers["checkCode"] = checkCode; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  res => {
    // console.log('----axios------res--------------');
    // console.log(res);
    if(res.data.code == API__code.LOGONEXPIRES) {
      // store.dispatch('logout', 1); //1:登录状态失效，需重新登录
      location.replace('/login');
    }
    // if(res.data.code == API__code.ERROR500) {
    //   window.location = '/500';
    // }
    return res;
  }, 
  error => { 
    // window.location = '/500';
    return Promise.reject(error);
  }
);

import API__basic from './upload.js'

import API__login from './login.js'

import API__product from './product.js'

import API__account from './account.js'

import API__trial from './trial.js'

import API_Common from './common'

import API_Models from './models'

import API_Admin from './admin'

import API_User from './user'

import API_Company from './company'

import API_wePro from './wePro'

import API_Stat from './statistics'

import API_Man from './manage'

import API_Integral from './integral'

import API_ResetPwEn from './resetPwEn'

export {
  API__code,
  API__login,
  API__basic,
  API__product,
  API__account,
  API__trial,
  API_Common,
  API_Models,
  API_Admin,
  API_User,
  API_Company,
  API_wePro,
  API_Stat,
  API_Man,
  API_Integral,
  API_ResetPwEn
}




// WEBPACK FOOTER //
// ./src/api/index.js